import React from 'react';
import { Button } from './ui/Button';
import { PriceDisplay } from './PriceDisplay';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-brand-black text-center" data-id="element-44">
      <div className="container mx-auto max-w-3xl" data-id="element-45">
        <h2 className="text-4xl md:text-6xl font-heading font-bold text-white mb-8" data-id="element-46">
          No necesitás más teoría.
          <br data-id="element-47" />
          <span className="text-brand-red" data-id="element-48">Necesitás estructura.</span>
        </h2>

        <Button className="text-xl px-12 py-6 mb-8" data-id="element-49">
          Descargá Código Deseo™ por{' '}
          <PriceDisplay amount={23.9} className="ml-2" data-id="element-50" />
        </Button>

        <p className="text-gray-400" data-id="element-51">
          Y empezá a operar desde el marco correcto.
        </p>
      </div>
    </section>;
}